import { useAppDispatch } from 'src/redux/Store';
import { makeStyles } from '@material-ui/core/styles';
import { openModal } from 'src/redux/actions/modalActions';
import { MODALS } from 'src/models/ModalModel';
import TextLink from 'src/components/UI/TextLink';
import UserPageHeader from 'src/components/Elements/User/UserPageHeader';
import UserCreditCardDisplayer from 'src/components/Elements/User/UserCreditCardDisplayer';
import UserBankAccountDisplayer from 'src/components/Elements/User/UserBankAccountDisplayer';

const useStyles = makeStyles(() => ({
  content: {
    maxWidth: '680px',
    margin: '0 auto',
    padding: '0 8px',
  },
  subheader: {
    fontSize: '0.75rem',
    fontWeight: 'bold',
    marginTop: '12px',
    marginBottom: '4px',
  },
}));

const UserPaymentSettingsPage = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const openAddCreditCardModal = () => {
    dispatch(openModal({
      modal: MODALS.addUserCreditCard,
    }));
  };

  return (
    <>
      <UserPageHeader title="Payment Information" />
      <div style={{ height: '96px' }} />
      <div className={classes.content}>
        <div className={classes.subheader}>Credit Cards</div>
        <UserCreditCardDisplayer />
        <TextLink onClick={() => openAddCreditCardModal()}>Add a credit card</TextLink>
        <br />
        <div className={classes.subheader}>Bank Accounts</div>
        <UserBankAccountDisplayer />
      </div>
    </>
  );
};

export default UserPaymentSettingsPage;
